import * as React from "react";
const SvgFiRrCloudCode = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-code_svg__a)">
      <path
        fill="#062147"
        d="M19.18 7.494c-.529-.203-.941-.555-1.191-1.018-1.775-3.298-5.461-5.035-9.175-4.313C5.524 2.8 2.86 5.43 2.185 8.708a8.8 8.8 0 0 0-.148 2.584c.062.674-.335 1.215-.577 1.478A5.48 5.48 0 0 0 .001 16.5c0 3.032 2.243 5.5 5 5.5h11.278c3.959 0 7.336-2.98 7.689-6.787.311-3.348-1.659-6.52-4.788-7.719m2.796 7.534C21.717 17.816 19.215 20 16.278 20H5c-1.654 0-3-1.57-3-3.5 0-.883.33-1.726.929-2.374.808-.876 1.199-1.948 1.099-3.02a6.8 6.8 0 0 1 .116-1.994c.515-2.498 2.544-4.501 5.05-4.986q.646-.124 1.283-.123a6.5 6.5 0 0 1 5.751 3.421 4.25 4.25 0 0 0 2.237 1.938c2.295.88 3.738 3.21 3.511 5.667m-11.389 1.72a.999.999 0 1 1-1.414 1.414l-2.44-2.44a2.49 2.49 0 0 1-.732-1.768c0-.668.26-1.297.733-1.769l2.394-2.394a.999.999 0 1 1 1.414 1.414L8.148 13.6a.5.5 0 0 0 0 .708zm6.681-4.562A2.48 2.48 0 0 1 18 13.954c0 .67-.26 1.295-.732 1.768l-2.44 2.44a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.44-2.44a.5.5 0 0 0 0-.707l-2.395-2.396a.999.999 0 1 1 1.414-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-code_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudCode;
